import { render, staticRenderFns } from "./modalTransportationSegmentUpdate.vue?vue&type=template&id=298dd69c&scoped=true"
import script from "./modalTransportationSegmentUpdate.vue?vue&type=script&lang=js"
export * from "./modalTransportationSegmentUpdate.vue?vue&type=script&lang=js"
import style0 from "./modalTransportationSegmentUpdate.vue?vue&type=style&index=0&id=298dd69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dd69c",
  null
  
)

export default component.exports